import { api } from 'api/api';
import { Endpoints } from 'api/constants';
import { TableDataResponse } from 'types/general';
import { ITeam } from 'types/income';
import { getSorting } from 'utils/general';
import { TeamsFilters } from './teams.types';

interface GetTeams {
  filters: Partial<TeamsFilters>;
}

interface CreateTeam {
  name: string;
  departmentId: string;
  hidden: boolean;
  managerId: string | null;
}

interface UpdateTeam {
  teamId: string;
  data: Partial<Omit<CreateTeam, 'departmentId'>>;
}

interface DeleteTeam {
  teamId: string;
}

export const loaders = {
  getTeams: ({ filters }: GetTeams) => {
    return api<TableDataResponse<ITeam>>({
      url: Endpoints.clientAdmin.teams.root,
      params: {
        page: filters.page,
        pageSize: filters.pageSize,
        ...getSorting(filters.sort),
        search: filters.search || undefined,
        filter: {
          teamIds: filters.teams,
          departmentIds: filters.departments,
          isHidden: filters.isHidden,
        },
      },
    });
  },
  createTeam: ({ ...data }: CreateTeam) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.teams.root,
      data,
      method: 'post',
    });
  },
  updateTeam: ({ teamId, data }: UpdateTeam) => {
    return api<{ id: string }>({
      url: Endpoints.clientAdmin.teams.byId.replace(':teamId', teamId),
      data,
      method: 'patch',
    });
  },
  deleteTeam: ({ teamId }: DeleteTeam) => {
    return api({
      url: Endpoints.clientAdmin.teams.byId.replace(':teamId', teamId),
      method: 'delete',
    });
  },
};
